import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function profileFields(profile) {
  return {
    business_name: profile?.businessName || "",
    industry: profile?.industry || "",
    business_description: profile?.description || "",
    knowledge: profile?.knowledge || "some",
  };
}

export async function generateQuiz(topic, difficulty, count, profile) {
  const { data } = await axios.post(`${API}/quiz/generate`, {
    topic,
    difficulty,
    count,
    ...profileFields(profile),
  });
  return data;
}

export async function generateScenario(topic, difficulty, profile) {
  const { data } = await axios.post(`${API}/scenario/generate`, {
    topic,
    difficulty,
    ...profileFields(profile),
  });
  return data;
}
